import React, { useEffect, useState } from 'react'
import Axios from '../../../axios/axios';
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams } from 'react-router-dom';
import imageCompression from "browser-image-compression";
import SupplierNavbar from '../Admin/SuppplierNavbar';
import SupplierSidebar from '../Admin/SupplierSidebar';




function SpareEdit() {
   const [spareModels, setSpareModels] = useState([]);
  const [spareBrand, setSpareBrand] = useState([]);
  const [spareCategory, setSpareCategory] = useState([]);
  const [spareRegion, setSpareRegion] = useState("");
  const [spareSeries, setSpareSeries] = useState("")
  const [catalogueFiles, setCatalogueFiles] = useState([]);
  const [spareSteering, setSpareSteering] = useState("");
  const [spareBodyType, setSpareBodyType] = useState("");
  const [spareTransmission, setSpareTransmission] = useState("");
  const [spareModification, setSpareModification] = useState("");
  const [spareEngine, setSpareEngine] = useState("");
  const [spareEngineCode, setSpareEngineCode] = useState("");
  const [spareGrade, setSpareGrade] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [series, setSeries] = useState([])
  const [region, setRegion] = useState([])
  const [uploading, setUploading] = useState(false)
  const [loading, setLoading] = useState(false);
  // const [image, setImage] = useState(null);
  const [name, setName] = useState("");
  const [years, setYears] = useState([])
  const [spareYear, setSpareYear] = useState("");
  const [price, setPrice] = useState("");
  const [spareProductType, setSpareProductType] = useState("");
  const [images, setImages] = useState([]); 
  const [partNo, setPartNo] = useState("");
  const [description, setDescription] = useState("");
  const [suppliers, setSuppliers] = useState([]);

  const [supplier, setSupplier] = useState({
  supplierId: "",
  name: "",
  location: "",
  contactNumber: "",
  email: ""
});

const [sidebarOpen, setSidebarOpen] = useState(true);
    
      useEffect(() => {
        const storedSupplier = sessionStorage.getItem("supplierInfo");
        if (storedSupplier) {
          const supplierInfo = JSON.parse(storedSupplier);
          setSupplier(supplierInfo);
        }
      }, []);


  const navigate = useNavigate()
  const { id } = useParams()

  const { partsId } = useParams()



  useEffect(() => {
    getCompleteData();
    getItems();
    getPartsById();
    setYears(getYears());
    
  }, [id]);

  const getCompleteData = async () => {
  try {
    const response = await Axios.get("/type-based-details");
    setSpareModels(response.data.spare.models);
    setSpareBrand(response.data.spare.brands);
    setSpareCategory(response.data.spare.categories);

    const supplierRes = await Axios.get("/supplier");
    setSuppliers(supplierRes.data.data || []);
  } catch (error) {
    console.error("Error fetching parts:", error);
  }
};


  const getItems = async () => {
    try {
      const result = await Axios.get(`/series`)
      const response = await Axios.get(`/regions`)
      console.log(result.data);
      setSeries(result.data)
      setRegion(response.data)


    } catch (error) {
      console.log(error);
    }
  }


  const getPartsById = async () => {
    try {
      const res = await Axios.get(`/parts/get/${id}`);
      const result = res.data;
      setName(result.name);
      setPartNo(result.partNo || "");
      setSelectedBrand(result.brandId);
      setSelectedModel(result.modelId);
      setSelectedCategory(result.categoryId);
      setCatalogueFiles(result.catalogue || []);
      setSpareSeries(result.seriesId || "");
      setSpareRegion(result.regionId || "");
      setSpareSteering(result.steering || "");
      setSpareBodyType(result.bodyType || "");
      setSpareTransmission(result.transmissionType || "");
      setSpareModification(result.modification || "");
      setSpareEngine(result.engine || "");
      setSpareEngineCode(result.engineCode || "");
      setSpareGrade(result.grade || "");
      setImages(result.images || []); // Changed from `image` to `images`
      setSpareProductType(result.productType || "");
      setSpareYear(result.year || "");
      setPrice(result.price || "");
      setDescription(result.description || "");
      setSupplier(
        result.supplier || {
          supplierId: "",
          name: "",
          location: "",
          contactNumber: "",
          email: "",
        }
      );


    } catch (error) {
      console.error('Error fetching part:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const formData = {
        name,
        partNo,
        modelId: selectedModel,
        brandId: selectedBrand,
        categoryId: selectedCategory,
        catalogue: catalogueFiles,
        steering: spareSteering,
        bodyType: spareBodyType,
        transmissionType: spareTransmission,
        modification: spareModification,
        engine: spareEngine,
        engineCode: spareEngineCode,
        seriesId: spareSeries,
        regionId: spareRegion,
        grade: spareGrade,
        images, // Changed from `image` to `images`
        year: spareYear,
        price,
        productType: spareProductType,
        description,
        supplier: supplier,
      };
  
      const response = await Axios.put(`/parts/update/${id}`, formData);
      toast.success("Part updated successfully!");
      navigate("/SupplierProducts");
    } catch (error) {
      console.error("Error updating part:", error);
      toast.error("Failed to update part");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSeries = (e) => {
    setSpareSeries(e.target.value);
  };

  const handleSelectRegion = (e) => {
    setSpareRegion(e.target.value);
  };


  const uploadFileHandler = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
  
    setUploading(true);
  
    try {
      const uploadedImages = await Promise.all(
        Array.from(files).map(async (file) => {
          const compressedFile = await imageCompression(file, {
            maxSizeMB: 0.2,
            maxWidthOrHeight: 800,
          });
  
          const formData = new FormData();
          formData.append("images", compressedFile);
  
          const { data } = await Axios.post("/upload-multiple", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
  
          return {
            name: file.name,
            url: data.fileUrls[0],
            public_id: data.public_id, // For Cloudinary (optional)
          };
        })
      );
  
      setImages([...images, ...uploadedImages]); // Append new images
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Failed to upload images");
    } finally {
      setUploading(false);
    }
  };

  const uploadCatalogueFileHandler = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    try {
      const formData = new FormData();
      formData.append('images', file); // Maintain the same field name for backend API compatibility
      setUploading(true);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await Axios.post('/upload-multiple', formData, config);
      console.log(data);

      setCatalogueFiles((prevFiles) => [
        ...prevFiles,
        {
          name: file.name,
          url: data.fileUrls[0], // Ensure the backend returns a file URL array
        },
      ]);

      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const handleSupplierChange = (e) => {
  const value = e.target.value;
  const selectedSupplier = suppliers.find(s => s._id === value);

  setSupplier({
    supplierId: value,
    name: selectedSupplier?.supplierName || "",
    location: selectedSupplier?.address || "",
    contactNumber: selectedSupplier?.phoneNumber || "",
    email: selectedSupplier?.emailAddress || "",
  });
};


  
  const removeImage = async (index, public_id) => {
    try {
      if (public_id) {
        await Axios.delete(`/parts/delete-image/${public_id}`);
      }
  
      // Remove from frontend state
      const updatedImages = [...images];
      updatedImages.splice(index, 1);
      setImages(updatedImages);
  
      toast.success("Image removed successfully");
    } catch (error) {
      console.error("Error deleting image:", error);
      toast.error("Failed to remove image");
    }
  };

  const removeCatalogue = async (catalogueId, fileUrl) => {
    try {
      console.log('Deleting Catalogue ID:', catalogueId);
      console.log('Deleting File URL:', fileUrl);

      if (!catalogueId || !fileUrl) {
        toast.warning('Catalogue ID and File URL are required!');
        return;
      }

      // Send delete request to backend
      const response = await Axios.delete(`/parts/delete-pdf/${catalogueId}`, {
        headers: { 'Content-Type': 'application/json' },
        data: { fileUrl }, // Sending fileUrl in the request body
      });

      console.log('Response from server:', response.data);

      if (response.data.success) {
        toast.success('Catalogue deleted successfully!');

        // Update frontend state to remove deleted file
        setCatalogueFiles((prevFiles) =>
          prevFiles.filter((file) => file._id !== catalogueId)
        );
      } else {
        toast.error('Failed to delete catalogue: ' + response.data.message);
      }
    } catch (error) {
      console.error('Error deleting catalogue:', error);

      if (error.response) {
        toast.error('Failed to delete catalogue: ' + error.response.data.message);
      } else if (error.request) {
        toast.error('Failed to delete catalogue: No response from the server!');
      } else {
        toast.error('Failed to delete catalogue: ' + error.message);
      }
    }
  };

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i);
  };



  return (
     <div className="enhanced-body">
          <SupplierNavbar
            supplier={supplier}
            setSupplier={setSupplier}
            toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          />
    
          <div className="container-fluid">
            <div className="row">
              {sidebarOpen && (
                <div className="col-md-2">
                  <SupplierSidebar />
                </div>
              )}
    
              <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
    

<div className="row">
<div className="col-12 grid-margin stretch-card ">
  <div className="card" style={{ maxHeight: '95vh', overflowY: 'auto', minHeight: '90vh' }}>

    <div className="card-body">
      <h4 className="card-title">Edit Parts</h4>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Name:</label>
          <input type="text" name="name" value={name}
            onChange={(e) => setName(e.target.value)}

            className="form-control" />
        </div>
        <div className="mb-3">
  <label>Part No:</label>
  <input
    type="text"
    name="partNo"
    value={partNo}
    onChange={(e) => setPartNo(e.target.value)}
    className="form-control"
    placeholder="Enter Part Number"
  />
</div>
<div className="form-group">
  <label>Description</label>
  <textarea
    className="form-control"
    rows="3"
    value={description}
    onChange={(e) => setDescription(e.target.value)}
    placeholder="Enter part description"
  />
</div>


        <div className="form-group">
          <label>Model</label>
          <select
            className="form-control"
            value={selectedModel}
            onChange={(e) => setSelectedModel(e.target.value)}
            required
          >
            <option value="">Select Model</option>
            {spareModels.map((model) => (
              <option key={model._id} value={model._id}>
                {model.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Brand</label>
          <select
            className="form-control"
            value={selectedBrand}
            onChange={(e) => setSelectedBrand(e.target.value)}
            required
          >
            <option value="">Select Brand</option>
            {spareBrand.map((brand) => (
              <option value={brand._id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Price</label>
          <input
            type="number"
            className="form-control"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
            placeholder="Enter Price"
          />
        </div>

        <div className="form-group">
  <label htmlFor="exampleInputPriority4">Product Type</label>
  <select
    className="form-control"
    value={spareProductType}
    onChange={(e) => setSpareProductType(e.target.value)}
  >
     <option value="">Select Product Type</option>
    <option value="Engineering">Engineering</option>
    <option value="Building">Building</option>
    <option value="Auto-Spare">Auto-Spare</option>
  </select>
</div>



      
        <div className="form-group">
  <label>Images</label>
  <div className="d-flex align-items-center mb-2">
    <input
      type="file"
      id="image-upload"
      className="d-none"
      multiple
      onChange={uploadFileHandler}
      accept="image/*"
    />
    <label
      htmlFor="image-upload"
      className="btn btn-primary btn-sm mb-0"
    >
      <i className="icon-plus"></i> Add Images
    </label>
  </div>

  {/* Show uploading spinner */}
  {uploading && (
    <div className="spinner-border text-primary" role="status">
      <span className="sr-only">Uploading...</span>
    </div>
  )}

  {/* Display uploaded images */}
  <div className="d-flex flex-wrap gap-2 mt-2">
    {images.map((img, index) => (
      <div key={index} className="position-relative">
        <img
          src={img.url}
          alt={img.name}
          height="80"
          className="rounded border"
        />
        <button
          type="button"
          className="btn btn-danger btn-xs position-absolute top-0 end-0"
          onClick={() => removeImage(index, img.public_id)}
        >
          ×
        </button>
      </div>
    ))}
  </div>
</div>


        <div class="form-group">
          <label for="exampleInputPriority4">Series</label>

          <select className='form-control' value={spareSeries} onChange={handleSelectSeries}>
            <option>Select</option>
            {series.map((item) => (

              <option key={item?._id} value={item?._id}>{item.name}</option>
            ))}

          </select>
        </div>
        <div class="form-group">
          <label for="exampleInputPriority4">Region</label>

          <select className='form-control' value={spareRegion} onChange={handleSelectRegion}>
            <option>Select</option>
            {region.map((item) => (

              <option key={item?._id} value={item?._id}>{item.name}</option>
            ))}

          </select>
        </div>
        <div className="form-group">
          <label>Category</label>
          <select
            className="form-control"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">Select Category</option>
            {spareCategory.map((category) => (
              <option value={category._id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="catalogueUpload">Catalogue Upload</label>
          <input
            type="file"
            className="form-control"
            accept=".pdf"
            onChange={uploadCatalogueFileHandler}

          />

          {uploading && (
            <div className="spinner-border" role="status">
              <span className="sr-only">Uploading...</span>
            </div>
          )}

          {catalogueFiles.map((file, index) => (
            <div key={index} className="mt-2">
              <a href={file.url} target="_blank" rel="noopener noreferrer">
                {file.name}
              </a>
              <button
               type='button'
                className="btn btn-danger btn-sm ml-2"
                onClick={() => removeCatalogue(file._id, file.url)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>

        <div className="form-group">
          <label htmlFor="exampleInputPriority4">Steering</label>
          <select
            className="form-control"
            value={spareSteering}
            onChange={(e) => setSpareSteering(e.target.value)}
          >
            <option>Select</option>
            <option value="speed-sensitive steering">SPEED-SENSITIVE STEERING</option>
            <option value="four-wheel steering">FOUR-WHEEL STEERING</option>
            <option value="power steering">POWER STEERING</option>

          </select>
        </div>

        <div className="form-group">
          <label htmlFor="exampleInputPriority4">BodyType</label>
          <select
            className="form-control"
            value={spareBodyType}

            onChange={(e) => setSpareBodyType(e.target.value)}
          >
            <option>Select</option>
            <option value="hatchback">HATCHBACK</option>
            <option value="MUV-SUV">MUV-SUV</option>
            <option value="seden">SEDEN</option>

          </select>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputPriority4">TransmissionType</label>
          <select
            className="form-control"
            value={spareTransmission}

            onChange={(e) => setSpareTransmission(e.target.value)}
          >
            <option>Select</option>
            <option value="automatic">AUTOMATIC</option>
            <option value="manual">MANUAL</option>

          </select>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputPriority4">Year</label>
          <select
            className="form-control"
            value={spareYear}
            onChange={(e) => setSpareYear(e.target.value)}
          >
            <option selected disabled>
              Select Year
            </option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="exampleInputPriority4">Modification</label>
          <select
            className="form-control"
            value={spareModification}

            onChange={(e) => setSpareModification(e.target.value)}
          >
            <option>Select</option>
            <option value="GXE10-AEPVK">GXE10-AEPVK</option>
            <option value="JCE15W-AWPVF">JCE15W-AWPVF</option>
            <option value="SXE10-AEAVF">SXE10-AEAVF</option>

          </select>
        </div>

        <div className="form-group">
          <label htmlFor="exampleInputPriority4">Engine</label>
          <select
            className="form-control"
            value={spareEngine}

            onChange={(e) => setSpareEngine(e.target.value)}
          >
            <option>Select</option>
            <option value="flat engine">FLAT ENGINE</option>
            <option value="v-engine">V-ENGINE</option>
            <option value="twin-cylinder">TWIN-CYLINDER</option>

          </select>
        </div>


        <div className="form-group">
          <label htmlFor="exampleInputPriority4">Engine Code</label>
          <select
            className="form-control"
            value={spareEngineCode}

            onChange={(e) => setSpareEngineCode(e.target.value)}
          >
            <option>Select</option>
            <option value="P1234">P1234</option>
            <option value="p6345">P6345E</option>
            <option value="p0987">P0987</option>

          </select>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputPriority4">GRADE</label>
          <select
            className="form-control"
            value={spareGrade}

            onChange={(e) => setSpareGrade(e.target.value)}
          >
            <option>Select</option>
            <option value="grade1">GRADE1</option>
            <option value="grade2">GRADE2</option>
            <option value="grade3">GRADE3</option>

          </select>
        </div>

       <div className="form-group">
  <label>Supplier</label>
  <select
    className="form-control"
    value={supplier.supplierId}
    onChange={handleSupplierChange}
  >
    <option value="">Select Supplier</option>
    {suppliers.map((sup) => (
      <option key={sup._id} value={sup._id}>
        {sup.supplierName}
      </option>
    ))}
  </select>
</div>


        <button type="submit" className="btn btn-primary mr-2" disabled={loading}>
          {loading ? (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          ) : (
            "Update"
          )}
        </button>
        <button type="button" onClick={() => navigate("/SupplierProducts")} className="btn btn-secondary ms-2">Cancel</button>
      <div style={{ marginBottom: '60px' }}></div>
</form>
      

      </div>
        </div>
      </div>
    </div>
  </div>
</div>
            </div>
          </div>
        
  )
}

export default SpareEdit
